export const blackAlpha = {
  blackA0: 'rgba(0, 0, 0, 0)',
  blackA1: 'rgba(0, 0, 0, 0.1)',
  blackA2: 'rgba(0, 0, 0, 0.2)',
  blackA3: 'rgba(0, 0, 0, 0.3)',
  blackA4: 'rgba(0, 0, 0, 0.40)',
  blackA5: 'rgba(0, 0, 0, 0.44)',
  blackA6: 'rgba(0, 0, 0, 0.58)', // glass effect
  blackA7: 'rgba(0, 0, 0, 0.62)',
  blackA8: 'rgba(0, 0, 0, 0.66)',
  blackA9: 'rgba(0, 0, 0, 0.7)',
  blackA10: 'rgba(0, 0, 0, 0.74)',
  blackA11: 'rgba(0, 0, 0, 0.78)',
  blackA12: 'rgba(0, 0, 0, 0.96)',
};
